import { useEffect } from 'react';
import type { RefObject } from 'react';

export function useTrapFocus(active: boolean, ref: RefObject<HTMLElement>) {
  useEffect(() => {
    if (!active || !ref.current) return undefined;

    const focusableElements = Array.from<HTMLElement>(
      ref.current.querySelectorAll(
        'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
      ),
    );

    const handleLoopFocus = (event: FocusEvent) => {
      if (ref.current && event.target instanceof Node && !ref.current?.contains(event.target)) {
        event.preventDefault();
        focusableElements[0]?.focus();
      }
    };

    document.addEventListener('focusin', handleLoopFocus);

    return () => {
      document.removeEventListener('focusin', handleLoopFocus);
    };
  }, [active, ref]);
}
